import React, { Fragment, Component } from "react";
import NavBar from "../../common/forms/NavbarCopy";
import { Row, Col, Container, Button } from "react-bootstrap";
import { Loader } from "../../common/forms/Loading/Loader";
import { AddNotification } from "../../Methods/Notificaition.jsx";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { subDirectory } from "../../../config.json";
import "../../../styles/BoatBookingCancellation.scss";
// import qrcode from "../../../images/boat/qrcode.png";
import { getCancellationHistory } from "../../../services/BookingCancellationService";
import { getLocalStorageValues } from "../../../services/boat";
import moment from "moment";
import { Link } from "react-router-dom";
import { Modal, Divider } from "antd";
import megaphone from "../../../images/boat/megaphone.png"

import { SkCancellationHistoryCard } from "../../common/skeleton/subcatCardSkeleton"

class CancellationHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            variant: "",
            message: "",
            BookingHistoryData: [],
            openNotification: false,
            Reasons: [],
            isCancellationHistoryLoading: true,
            isCancellationHistoryAvailable: false,
            // currentdate: moment(new Date()).format("DD/MM/YYYY"),
        };
    }

    componentDidMount = async () => {
        await this.CancellationHistory();
        await this.setState({ loading: false });

    };

    CancellationHistory = async () => {
        this.setState({ loading: true })

        let data = {
            UserId: await getLocalStorageValues("UserId"),
            // UserId:"5214"
        };

        const res = await getCancellationHistory(data);
        if (res.data.StatusCode === 1) {
            if (res.data.Response.length > 0) {
                this.setState({ CancellationHistoryData: res.data.Response, isCancellationHistoryLoading: false, isCancellationHistoryAvailable: true });
            }
        } else {
            this.setState({ CancellationHistoryData: [], loading: false, isCancellationHistoryLoading: false, isCancellationHistoryAvailable: false });
        }

    };


    frameLoadAllBookings = () => {
        const allBookings = this.state.CancellationHistoryData;


        return allBookings.map((allBookings) => (
            <div className="w-100 historycolor d-flex justify-content-center container my-4 mx-auto ">
                <Row className="px-3 w-100">

                    <Col md={12}>
                        <Row>
                            {/* <Col md={4} className="">
                                <div>
                                    <img src={megaphone} className="imgwidth" />
                                </div>

                            </Col> */}
                            <Col md={12} className="">
                                <div className="ctitle text-left"> {allBookings.BoatHouseName}</div>
                                <div className="textdiv">
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2"> Booking Id  </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1">{allBookings.BookingId} </div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2"> Boat Type  </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1">{allBookings.BoatTypeName} - {allBookings.BoatSeaterName}</div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2"> Time Slot  </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1">{allBookings.TimeSlot}</div>

                                    </div>

                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2">  Booking Date </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue"> {allBookings.BookingDate?.split(" ")[0]} </div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2"> Booking Pin </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1">  {allBookings.BookingPin} </div>

                                    </div>
                                    <div className="receiptdisplay2">
                                        <div className="receiptbid2">   Boat Type </div>
                                        <div className="receiptbid3">:</div>
                                        <div className="receiptvalue1"> {allBookings.PremiumStatus}</div>

                                    </div>

                                    <div >
                                        <div className="Amt mt-2" >₹ {allBookings.InitNetAmount}</div>
                                    </div>
                                </div>
                            </Col>

                        </Row>
                    </Col>
                </Row>


            </div>
        ));
    };
    render() {
        const { loading, openNotification, isCancellationHistoryLoading, isCancellationHistoryAvailable } = this.state;


        return (
            <Fragment>
                {/* <Loader fullPage loading={loading} /> */}
                <AddNotification
                    visible={openNotification}
                    variant={this.state.variant}
                    message={this.state.message}
                    onClose={() => this.setState({ openNotification: false })}
                />
                <div class="webCheckInc">
                    <NavBar {...this.props} />
                    <Container fluid className="webCheckIn-con1">
                        <div className="cancelscroll">
                        <Row className="pt-3 mb-3">
                            <div
                                className="d-flex mx-auto align-items-end "
                                style={{ width: "90%" }}
                            >
                                <div
                                    className="d-flex align-items-center cancelhomecolor initialpage"
                                    style={{ fontSize: "16px", color: "black" }}
                                    onClick={() => {
                                        this.props.history.push(`${subDirectory}/boatBookingCancellation`);
                                    }}
                                >
                                    <BsArrowLeft className="mr-2" />
                                    Back 
                                </div>
                                <div className=" titlediv cancelhomecolor d-flex justify-content-center">
                                    Boat Cancellation History
                                </div>

                            </div>
                            {/* </Col> */}
                        </Row>

                        {isCancellationHistoryLoading && <div className="historycolor d-flex justify-content-center container my-4 mx-auto "> <SkCancellationHistoryCard viewBox="0 0 650 400" /></div>}
                        {!isCancellationHistoryLoading && isCancellationHistoryAvailable && <div className="his-div">{this.frameLoadAllBookings()}</div>}
                        {!isCancellationHistoryLoading && !isCancellationHistoryAvailable && <div className="cnd"><div className="cancelnodata">No data found </div></div>}
                   </div>
                    </Container>
                </div>
                <>

                </>
            </Fragment>
        );
    }
}
export default CancellationHistory;


